import { render } from "./CreateCategory.vue?vue&type=template&id=0b617772&scoped=true"
import script from "./CreateCategory.vue?vue&type=script&lang=js"
export * from "./CreateCategory.vue?vue&type=script&lang=js"

import "./CreateCategory.vue?vue&type=style&index=0&id=0b617772&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b617772"]])

export default __exports__